
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remote-work-guides",
      function () {
        return require("private-next-pages/remote-work-guides/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remote-work-guides"])
      });
    }
  